// This hook is the same as redux useDispatch but it makes sure that the typing accepts thunk hooks.
import { ThunkDispatch } from 'redux-thunk';
import { useDispatch } from 'react-redux';
import { AnyAction } from 'redux';
import { RootState } from 'Store/index';
const useAppDispatch = () => useDispatch<ThunkDispatch<RootState, any, AnyAction>>(); // Export a hook that can be reused to resolve types

export default useAppDispatch;
